import store from "@/store";
import emailApi from "./email.api";
import Logger from "@/helpers/logger";
import { getBundleId } from "@/helpers";

class EmailService {
  async getEmailList() {
    try {
      const data = await emailApi.getEmailList();
      store.dispatch("currentDomainMailboxDetails", data?.accounts || []);
      return data;
    } catch (e) {
      Logger.error("`getEmailList` service", e);
      return Promise.reject(e);
    }
  }

  async createEmail(payload) {
    try {
      return await emailApi.createEmail(payload);
    } catch (e) {
      Logger.error("`createEmail` service", e);
      return Promise.reject(e);
    }
  }

  async getCatchAll() {
    try {
      return await emailApi.getCatchAll();
    } catch (e) {
      Logger.error("`getCatchAll` service", e);
      return Promise.reject(e);
    }
  }

  async getEmailForwarders() {
    try {
      return await emailApi.getEmailForwarders();
    } catch (e) {
      Logger.error("`getEmailForwarders` service", e);
      return Promise.reject(e);
    }
  }

  async fetchImportTasks() {
    try {
      return await emailApi.fetchImportTasks();
    } catch (e) {
      Logger.error("`fetchImportTasks` service", e);
      return Promise.reject(e);
    }
  }

  async importEmail(payload) {
    try {
      return await emailApi.importEmail(payload);
    } catch (e) {
      Logger.error("`importEmail` service", e);
      return Promise.reject(e);
    }
  }

  async resumeImportEmail(payload, token, bundleId) {
    try {
      return await emailApi.resumeImportEmail(payload, token, bundleId);
    } catch (e) {
      Logger.error("`resumeImportEmail` service", e);
      return Promise.reject(e);
    }
  }

  async deleteAndCreate(payload) {
    try {
      return await emailApi.deleteAndCreate(payload);
    } catch (e) {
      Logger.error("`deleteAndCreate` service", e);
      return Promise.reject(e);
    }
  }

  async removeAlias(payload) {
    try {
      return await emailApi.removeAlias(payload);
    } catch (e) {
      Logger.error("`removeAlias` service", e);
      return Promise.reject(e);
    }
  }

  async updateAlias(payload) {
    try {
      return await emailApi.updateAlias(payload);
    } catch (e) {
      Logger.error("`updateAlias` service", e);
      return Promise.reject(e);
    }
  }

  async getEmailAccountBackupState(aids) {
    try {
      const bid = getBundleId();
      return await emailApi.getEmailAccountBackupState({ aids, bid });
    } catch (e) {
      Logger.error("`getEmailAccountBackupState` service", e);
      return Promise.reject(e);
    }
  }

  getAllSuspensions(accountId) {
    try {
      return emailApi.getAllSuspensions(accountId);
    } catch (e) {
      Logger.error("`getAllSuspensions` service", e);
      return Promise.reject(e);
    }
  }

  setCatchAll(payload) {
    try {
      return emailApi.setCatchAll(payload);
    } catch (e) {
      Logger.error("`setCatchAll` service", e);
      return Promise.reject(e);
    }
  }

  removeCatchAll(payload = {}) {
    try {
      return emailApi.removeCatchAll(payload);
    } catch (e) {
      Logger.error("`removeCatchAll` service", e);
      return Promise.reject(e);
    }
  }

  deleteEmail(payload) {
    try {
      return emailApi.deleteEmail(payload);
    } catch (e) {
      Logger.error("`deleteEmail` service", e);
      return Promise.reject(e);
    }
  }

  updateConfig(payload) {
    try {
      return emailApi.updateConfig(payload);
    } catch (e) {
      Logger.error("`updateConfig` service", e);
      return Promise.reject(e);
    }
  }

  getAliasList(params) {
    try {
      return emailApi.getAliasList(params);
    } catch (e) {
      Logger.error("`getAliasList` service", e);
      return Promise.reject(e);
    }
  }

  addAlias(payload) {
    try {
      return emailApi.addAlias(payload);
    } catch (e) {
      Logger.error("`addAlias` service", e);
      return Promise.reject(e);
    }
  }

  resetPassword(payload) {
    try {
      return emailApi.resetPassword(payload);
    } catch (e) {
      Logger.error("`resetPassword` service", e);
      return Promise.reject(e);
    }
  }

  suspend(payload) {
    try {
      return emailApi.suspend(payload);
    } catch (e) {
      Logger.error("`suspend` service", e);
      return Promise.reject(e);
    }
  }

  unsuspend(payload) {
    try {
      return emailApi.unsuspend(payload);
    } catch (e) {
      Logger.error("`unsuspend` service", e);
      return Promise.reject(e);
    }
  }

  createForwarder(payload) {
    try {
      return emailApi.createForwarder(payload);
    } catch (e) {
      Logger.error("`createForwarder` service", e);
      return Promise.reject(e);
    }
  }

  deleteForwarder(payload) {
    try {
      return emailApi.deleteForwarder(payload);
    } catch (e) {
      Logger.error("`deleteForwarder` service", e);
      return Promise.reject(e);
    }
  }

  forwarderRecipientAdd(payload) {
    try {
      return emailApi.forwarderRecipientAdd(payload);
    } catch (e) {
      Logger.error("`forwarderRecipientAdd` service", e);
      return Promise.reject(e);
    }
  }

  forwarderRecipientRemove(payload) {
    try {
      return emailApi.forwarderRecipientRemove(payload);
    } catch (e) {
      Logger.error("`forwarderRecipientRemove` service", e);
      return Promise.reject(e);
    }
  }

  sendLoginDetails(payload) {
    try {
      return emailApi.sendLoginDetails(payload);
    } catch (e) {
      Logger.error("`sendLoginDetails` service", e);
      return Promise.reject(e);
    }
  }
}

const emailService = new EmailService();

export default emailService;
